import { VcenterController } from '../controller/VcenterController';
import { VcenterSpecifics, ViewTypes } from '../types';
import { Observable } from 'rxjs';
import { IntegrationActionContext } from '../../../integrationsMarketplaceGridInstalled/types';
import { TagActionContext } from '../../../../tagsManager/common/types/TagActionContext';
import { Company } from '../../../../tagsManager/types/tag-data';
import { BaseIntegrationWebComponent } from '../../BaseIntegrationWebComponent';
import { Integration, IntegrationData } from '../../types';

export class VcenterWebComponent extends BaseIntegrationWebComponent<VcenterSpecifics> {
  public controller!: VcenterController;
  private viewData: Integration | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: VcenterController,
    });
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public get valid(): boolean {
    if (!this.controller.view.formGroup) {
      return false;
    }
    return this.controller.view.formGroup.valid;
  }

  public get formContext(): IntegrationActionContext {
    const context = this.getAttribute('context');

    if (!TagActionContext.isValid(context)) {
      throw new Error(`Vcenter form context not valid: ${context}`);
    }

    return context as IntegrationActionContext;
  }

  public set formContext(context: IntegrationActionContext) {
    this.setAttribute('context', context);
  }

  public setActionContext(context: IntegrationActionContext): void {
    this.controller.view.context = context;
  }

  public setViewData(data: Integration | null): void {
    this.viewData = data;
  }

  public getViewData(): Integration | null {
    return this.viewData;
  }

  public getCompanyId(): string {
    return this.controller.view.dom.$companyFormField.value as string;
  }

  public getNameValue(): string {
    return this.controller.view.dom.$integrationName.value as string;
  }

  public getHostnameValue(): string {
    return this.controller.view.dom.$hostName.value as string;
  }

  public getPortValue(): number {
    return this.controller.view.dom.$port.value as number;
  }

  public getUsernameValue(): string {
    return this.controller.view.dom.$username.value as string;
  }

  public getPasswordValue(): string {
    return this.controller.view.dom.$password.value as string;
  }

  public getCustomizeSyncCheckboxValue(): boolean {
    return this.controller.view.dom.$customizeSyncCheckbox.getFormValue();
  }

  public getRetryAuthenticationTimeToWaitValue(): number {
    return this.controller.view.dom.$retryAuthenticationTimeToWait.value as number;
  }

  public getRetryAuthenticationMaxAttemptsValue(): number {
    return this.controller.view.dom.$retryAuthenticationMaxAttempts.value as number;
  }

  public getCertificateValue(): string {
    return '';
    // return this.controller.view.dom.$certificate.value as string;
  }

  public getVerifyTLSCertificateValue(): boolean {
    return this.controller.view.dom.$verifyTLSCertificate.getFormValue();
  }

  public getViewTypeValue(): number {
    return this.controller.view.dom.$viewTypeHostsAndClusters.checked
      ? ViewTypes.HostsAndClusters
      : ViewTypes.VmsAndTemplates;
  }

  public setCompany(company: Company) {
    this.controller?.setCompany(company);
  }

  public setIntegrationId(id: string) {
    this.controller?.setIntegrationId(id);
  }

  public async setIntegrationData(integration: IntegrationData<VcenterSpecifics>) {
    await this.controller.view.setIntegrationData(integration);
  }
}
